import {
    type FormInput,
    FormInputComponents,
    type IFormField,
} from '../support.type';
import { type FormFieldInput } from './FormFieldInput';
import { type FormFieldImageUploader } from './FormFieldImageUploader';
import { type FormFieldRating } from './FormFieldRating';

export abstract class FormField<T> implements IFormField<T> {
    protected _value: T | null = null;
    protected _isValid = true;
    readonly isRequired: boolean = false;
    readonly key: number;
    readonly label: string = '';
    readonly description: string = '';
    constructor(input: FormInput) {
        this.key = input.key;
        this.label = input.persianTitle;
        this.description = input.description;
        this.isRequired = !!input.isRequired;
    }

    abstract component: FormInputComponents;
    get value() {
        return this._value;
    }

    abstract get data(): string;

    get isValid() {
        return this._isValid;
    }

    get requiredError() {
        return 'موارد مورد نیاز را وارد کنید';
    }

    validator(val: T | null) {
        if (!val && this.isRequired) {
            this._isValid = false;
            return this.requiredError;
        }
        return true;
    }

    validateCurrentField() {
        return this.validator(this.value);
    }

    updateValue(val: T | null) {
        this._value = val;
        this.validator(val);
    }

    isInput(): this is FormFieldInput {
        return this.component === FormInputComponents.MrInput;
    }

    isImageUploader(): this is FormFieldImageUploader {
        return this.component === FormInputComponents.FileUploader;
    }

    isRating(): this is FormFieldRating {
        return this.component === FormInputComponents.MrRating;
    }
}
